import { zodResolver } from "@hookform/resolvers/zod";
import { Col, Form, Row } from "antd";
import { SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";
import { schemeFormCauseAnalysis } from "../../../features/forms/schemas/schemaFormCauseAnalysis";
import { isDev } from "../../../utils/dev";
import spacing from "../../ui/spacingConfig";
import FieldTextArea from "../fields/FieldTextArea";
import FieldUpload from "../fields/FieldUpload/FieldUpload";

export const formName = "form-event-cause-analysis";

export type FormCauseAnalysisSchema = z.infer<typeof schemeFormCauseAnalysis>;

type Props = {
  onSubmit: SubmitHandler<FormCauseAnalysisSchema>;
  defaultValues?: FormCauseAnalysisSchema;
};

const FormCauseAnalysis: React.FC<Props> = ({ onSubmit, defaultValues }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormCauseAnalysisSchema>({
    defaultValues,
    resolver: zodResolver(schemeFormCauseAnalysis),
  });

  if (isDev) {
    const formValues = watch(); // Get the form values state
    console.log("formValues", formValues);
    console.log("errors", errors);
  }

  return (
    <Form
      id={formName}
      onFinish={handleSubmit(onSubmit)}
      labelCol={{ span: 4 }}
    >
      <FieldTextArea<FormCauseAnalysisSchema>
        errorMessage={errors?.description?.message}
        control={control}
        name="description"
        label="Analyse des causes"
        placeholder="Description..."
        isVertical
      />
      <Row>
        <Col span={spacing.m}>
          <FieldUpload<FormCauseAnalysisSchema>
            errorMessage={errors.attachedFiles?.message}
            name="attachedFiles"
            control={control}
            listType="picture"
            label=""
            placeholder=""
          />
        </Col>
      </Row>
    </Form>
  );
};

export default FormCauseAnalysis;
